import styled from 'styled-components';

export const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 0.5rem 1rem;
    gap: 1rem;

    h1 {
        font-family: ${({ theme }) => theme.uiBricks?.headlineFontFamily};
        font-weight: ${({ theme }) => theme.uiBricks?.headlineFontWeight};
        font-size: ${({ theme }) => theme.uiBricks?.headlineFontSize};
        margin: 0;
        margin-top: 1rem;
    }
    p {
        font-family: ${({ theme }) => theme.uiBricks?.primaryFontFamily};
        font-size: ${({ theme }) => theme.uiBricks?.primaryFontSize};
        margin: 0;
    }
`;
